import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Frete } from '../models/frete';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class FreteService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc, uf, idCD?, idTransp?, idMod?) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '')
      .set('uf', uf ? uf : '')
      .set('idCD', idCD ? idCD.toString() : '')
      .set('idTransp', idTransp ? idTransp.toString() : '')
      .set('idMod', idMod ? idMod.toString() : '');

    return this.http.get<any>(globals.apiUrl + '/api/Frete/ListaPag',
      {
        params: parametros
      });
  }

  consultarFretes() {
    return this.http.get<Frete[]>(globals.apiUrl + '/api/Frete/Lista');
  }

  consultarPorIdFrete(idFrete) {
    return this.http.get<any>(globals.apiUrl + '/api/Frete/Buscar',
      { params: new HttpParams().set('id', idFrete) });
  }

  salvar(frete: Frete) {
    return this.http.post(globals.apiUrl + '/api/Frete/Salvar', frete,
      { responseType: 'text' });
  }

  vincularTransportadora(uf: string, idTransportadora: string, idCD?: number) {
    const parametros = new HttpParams()
      .set('uf', uf)
      .set('idTransportadora', idTransportadora)
      .set('idCD', idCD ? idCD.toString() : '');

    return this.http.get<any>(globals.apiUrl + '/api/Frete/VincularTransportadora',
      {
        params: parametros
      });
  }

  importarFretes(dados, idCD?: number, idMod?: number, idTransp?: number) {
    const parametros = new HttpParams()
      .set('idCD', idCD ? idCD.toString() : '')
      .set('idMod', idMod ? idMod.toString() : '')
      .set('idTransp', idTransp ? idTransp.toString() : '');

    return this.http.post(globals.apiUrl + '/api/Frete/ImportarFretes', dados,
      { params: parametros });
  }

  baixarModelo() {
    return this.http.get(globals.apiUrl + '/api/Frete/BaixarModelo', { responseType: 'blob' });
  }

  buscarPorIbge(ibge, idCD?: number) {
    const parametros = new HttpParams()
      .set('ibge', ibge)
      .set('idCD', idCD ? idCD.toString() : '');

    return this.http.get<any>(globals.apiUrl + '/api/Frete/BuscarPorIbge',
      { params: parametros });
  }

  listarPorIbge(ibge, idCD?: number) {
    const parametros = new HttpParams()
      .set('ibge', ibge)
      .set('idCD', idCD ? idCD.toString() : '');

    return this.http.get<any>(globals.apiUrl + '/api/Frete/ListarPorIbge',
      { params: parametros });
  }

  naoExisteFaixa(frete: Frete, valor: number) {
    return (frete !== null && frete !== undefined && valor !== null && valor !== undefined && !isNaN(valor) &&
      !frete.faixas.some(f => Number(valor.toFixed(2)) >= f.de && Number(valor.toFixed(2)) <= f.ate));
  }

  buscarDescontoDoFrete(frete: Frete, valor: number) {
    if (this.naoExisteFaixa(frete, valor) || frete === null || frete === undefined || valor === null || valor === undefined || isNaN(valor)) {
      return 0;
    } else {
      return frete.faixas.find(f => Number(valor.toFixed(2)) >= f.de && Number(valor.toFixed(2)) <= f.ate).percentual;
    }
  }

  exportarFretes(idCDs?: number[], multiCD?: boolean, idMod?, idTransp?) {
    return this.http.post(globals.apiUrl + '/api/Frete/ExportarFretes',
      { idCDs: idCDs === null? [] : idCDs, multiCD: multiCD, idMod: idMod, idTransp: idTransp },
      { responseType: 'blob' }
    );
  }
}
